export default [
  {
    path: '/dictionaryV3/:key?',
    name: 'dictionaryV3',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/dictionary/DictionaryListV3.vue'),
    meta: {},
  },
];
